// @ts-strict-ignore
import React, { useMemo } from 'react';
import { BrandColor } from '@styleseat/brand';
import { Box, Inline } from '@styleseat/ui';
import {
  BodyText,
  Stack,
  HeaderText,
} from '../../../ui';
import { ReviewStarSummaryItem } from './ReviewStarSummaryItem';
import { RatingsSummary } from '../../../../store/RatingsSummary.model';
import { BasicStarFilledIcon } from '../../../ui/Icons';

const STAR_LEVELS = [
  1,
  2,
  3,
  4,
  5,
];

type ReviewStarSummaryProps = {
  standalonePage?: boolean;
  ratingsSummary: RatingsSummary;
};

export const ReviewStarSummary: React.FCWithChildren<ReviewStarSummaryProps> = ({
  standalonePage,
  ratingsSummary,
}) => {
  /**
   * We do not display ratings if the pro does not
   * have any
   */
  const hasNoRatings = ratingsSummary.total === 0;

  const summaryText = useMemo(() => {
    const avgRating = ratingsSummary.average_rating;
    const ratingString = avgRating.toFixed?.(1) || '';
    return `${ratingString} (${ratingsSummary.total} Reviews)`;
  }, [ratingsSummary]);

  return (
    <React.Fragment>
      <Stack
        paddingY={16}
        alignItems="center"
        space={4}
        borderStyle="solid"
        borderWidth={standalonePage ? 0 : 1}
        borderColor={BrandColor.LightGrey}
        color={BrandColor.WhiteWash}
        testID="review-star-summary"
      >
        <Inline justifyContent="center" space={4}>
          <BasicStarFilledIcon
            color={BrandColor.Yellow}
            width={14}
            height={14}
          />
          <HeaderText testID="review-summary-average-stars-and-count" level={4}>{summaryText}</HeaderText>
        </Inline>
        {
          STAR_LEVELS.map(itemStars => (
            <ReviewStarSummaryItem
              key={itemStars}
              itemStars={itemStars}
              itemRatings={ratingsSummary.stars[itemStars]}
              totalRatings={ratingsSummary.total}
            />
          ))
        }
      </Stack>
      {hasNoRatings && standalonePage && (
        <Box padding={40} justifyContent="center" alignItems="center">
          <BodyText appearance="large" weight="bold">
            Your future client reviews and ratings will be listed here.
          </BodyText>
        </Box>
      )}
    </React.Fragment>
  );
};
